/* ==================================================
   FIX: Allow product link navigation in mini cart
   ================================================== */

document.addEventListener('click', function (e) {
  const link = e.target.closest(
    '#mini-cart-upsell-left a, .t4s-minicart-recommendations a'
  );

  if (!link) return;

  // Stop cart JS from blocking navigation
  e.stopPropagation();

  // Force navigation
  window.location.href = link.href;
}, true); // <-- capture phase (VERY IMPORTANT)
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-upsell-add');
  if (!btn) return;

  e.preventDefault();

  const variantId = btn.dataset.variantId;
  const qty = parseInt(btn.dataset.quantity || 1, 10);

  if (!variantId) return;

  if (!window.T4SThemeSP || !T4SThemeSP.Cart) {
    console.error('Kalles Cart API not found');
    return;
  }

  // 🔥 THIS IS THE MAGIC
  T4SThemeSP.Cart.addItem({
    id: variantId,
    quantity: qty
  });

  // 🔥 FORCE MINI CART REFRESH
  setTimeout(function () {
    T4SThemeSP.Cart.render();
  }, 300);
});
document.addEventListener('click', function (e) {
  const link = e.target.closest('[data-allow-link]');
  if (!link) return;

  // Allow normal navigation
  e.stopPropagation();
});
// ✅ Allow product title navigation inside mini cart
document.addEventListener('click', function (e) {
  const link = e.target.closest('a[data-allow-link]');
  if (!link) return;

  // Stop ONLY cart JS, allow browser navigation
  e.stopImmediatePropagation();

  window.location.href = link.href;
}, true);